import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { BLOGS } from '../data';
import { useReveal } from '../hooks/useReveal';
import ParallaxHero from '../components/ParallaxHero';

const CATS=['All','Web Development','Digital Marketing','Business Growth','Mobile Dev','E-Commerce'];

export default function Blog() {
  const [active,setActive]=useState('All');
  useReveal();
  const posts=active==='All'?BLOGS:BLOGS.filter(b=>b.cat===active);
  return (
    <>
      <Helmet>
        <title>Blog | ITClave — Tech Insights for Indian Businesses</title>
        <meta name="description" content="Tech insights, digital marketing tips, SEO guides, and business growth strategies for Indian entrepreneurs and businesses from ITClave."/>
        <meta name="keywords" content="IT blog India, digital marketing tips India, web development blog India, SEO guide India, tech insights Indian business"/>
      </Helmet>
      <ParallaxHero
        page="blog"
        eyebrow="Insights & Tutorials"
        title="Blog"
        subtitle="Actionable guides, case studies, and tech insights for businesses across India."
        cta={false}
      />
      <section style={{background:'var(--bg)',padding:'80px 0'}}>
        <div className="container">
          <div style={{display:'flex',gap:10,marginBottom:40,flexWrap:'wrap'}}>
            {CATS.map(cat=><button key={cat} onClick={()=>setActive(cat)} style={{padding:'8px 18px',borderRadius:100,fontSize:'.81rem',fontWeight:700,border:'1.5px solid',cursor:'pointer',transition:'all .3s',borderColor:active===cat?'transparent':'var(--border)',background:active===cat?'var(--grad)':'var(--bg2)',color:active===cat?'#fff':'var(--text2)'}}>{cat}</button>)}
          </div>
          {posts.length===0?(
            <div style={{textAlign:'center',padding:'60px 0',color:'var(--text3)'}}><div style={{fontSize:'3rem',marginBottom:12}}>📝</div><p>No posts in this category yet. Check back soon!</p></div>
          ):(
            <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:24}} className="blog-grid">
              {posts.map((b,i)=>(
                <article key={b.slug} className="reveal" style={{background:'#fff',border:'1px solid var(--border2)',borderRadius:22,overflow:'hidden',transition:'all .3s',boxShadow:'var(--sh)',transitionDelay:`${i*.1}s`}} onMouseOver={e=>{e.currentTarget.style.transform='translateY(-6px)';e.currentTarget.style.boxShadow='var(--sh-xl)';}} onMouseOut={e=>{e.currentTarget.style.transform='';e.currentTarget.style.boxShadow='var(--sh)';}}>
                  <div style={{height:200,overflow:'hidden',position:'relative'}}>
                    <img src={b.img} alt={b.title} loading="lazy" style={{width:'100%',height:'100%',objectFit:'cover',transition:'transform .6s'}} onMouseOver={e=>e.target.style.transform='scale(1.07)'} onMouseOut={e=>e.target.style.transform='scale(1)'}/>
                    <span style={{position:'absolute',top:14,left:14,background:'linear-gradient(135deg,#E8315B,#7B52AB,#4BB8E8)',color:'#fff',padding:'4px 12px',borderRadius:100,fontSize:'.67rem',fontWeight:700,letterSpacing:'.06em',textTransform:'uppercase'}}>{b.cat}</span>
                  </div>
                  <div style={{padding:'20px 22px 24px'}}>
                    <div style={{display:'flex',gap:12,marginBottom:10}}><span style={{fontSize:'.73rem',color:'var(--text3)',fontWeight:600}}>📅 {b.date}</span><span style={{fontSize:'.73rem',color:'var(--purple)',fontWeight:700}}>⏱ {b.read}</span></div>
                    <h2 style={{fontFamily:"'Outfit',sans-serif",fontSize:'1rem',fontWeight:800,color:'var(--text)',marginBottom:8,lineHeight:1.38,letterSpacing:'-.02em'}}>{b.title}</h2>
                    <p style={{fontSize:'.84rem',color:'var(--text2)',lineHeight:1.72,marginBottom:16}}>{b.excerpt}</p>
                    <div style={{display:'flex',alignItems:'center',gap:8,paddingTop:14,borderTop:'1px solid var(--border2)'}}>
                      <div style={{width:28,height:28,borderRadius:'50%',background:'linear-gradient(135deg,#E8315B,#4BB8E8)',color:'#fff',fontSize:'.63rem',fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',fontFamily:"'Outfit',sans-serif",flexShrink:0}}>{b.av}</div>
                      <span style={{fontSize:'.77rem',fontWeight:700,color:'var(--text2)'}}>{b.author}</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
      <style>{`@media(max-width:1100px){.blog-grid{grid-template-columns:repeat(2,1fr)!important}}@media(max-width:640px){.blog-grid{grid-template-columns:1fr!important}}`}</style>
    </>
  );
}
